import styled from 'styled-components';

export const ItemTop = styled.div<{ $url: string }>`
    ${({ $url }) => ($url ? `background-image:url(${$url})` : '')}
`;
